import { DbLoadBreakageReport } from "../../../data/usecases/load-breakage-reports";
import { LoadBreakageReports } from "../../../domain/usecases/load-breakage-report";

import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbLoadBreakageReport = (): LoadBreakageReports =>
  new DbLoadBreakageReport(
    makeApiUrl("/breakage"),
    makeAuthorizeHttpClientDecorator()
  );
